// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingPanel_spinner__MChVZ","loadingPanel":"LoadingPanel_loadingPanel__er6qF","overlay":"LoadingPanel_overlay__GCw3e"};